import { apiGet } from '../../api';
import { ApiPath, ApiNames } from '../../enums';

import { CurrentProfitAndExpectedReturns } from './model';

export async function getCurrentProfitAndExpectedReturns(): Promise<CurrentProfitAndExpectedReturns[]> {
  return apiGet<CurrentProfitAndExpectedReturns[]>(
    ApiNames.MonorepoApiEndpoint,
    ApiPath.CurrentProfitAndExpectedReturns,
    true
  );
}
